'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommercialIcon = function (_React$Component) {
    _inherits(CommercialIcon, _React$Component);

    function CommercialIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CommercialIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommercialIcon.__proto__ || Object.getPrototypeOf(CommercialIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'commercial-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Shopping-E-commerce_Shops_shop-1', 'data-name': 'Shopping-E-commerce / Shops / shop-1', transform: 'translate(0 0)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Group' },
                        _react2.default.createElement(
                            'g',
                            { id: 'shop-1' },
                            _react2.default.createElement('path', { fill: color, id: 'Shape', d: 'M21.379,11.9a3.7,3.7,0,0,1-2.928-1.511.25.25,0,0,0-.4,0,3.592,3.592,0,0,1-5.856,0,.25.25,0,0,0-.4,0A3.7,3.7,0,0,1,8.874,11.9a3.7,3.7,0,0,1-2.929-1.511.25.25,0,0,0-.4,0A3.7,3.7,0,0,1,2.621,11.9a3.47,3.47,0,0,1-.384-.022.249.249,0,0,0-.278.249V21.15a1.5,1.5,0,0,0,1.5,1.5h17a1.5,1.5,0,0,0,1.5-1.5V12.134a.252.252,0,0,0-.082-.185.248.248,0,0,0-.191-.064C21.584,11.894,21.482,11.9,21.379,11.9Zm-6.422,3.11a.382.382,0,0,1,.4-.361h3.2a.382.382,0,0,1,.4.361v5.139a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5Zm-9.126-.361a.355.355,0,0,0-.374.333v3.334a.355.355,0,0,0,.374.333h5.247a.356.356,0,0,0,.375-.333V14.982a.356.356,0,0,0-.375-.333Z', fillRule: 'evenodd' }),
                            _react2.default.createElement('path', { fill: color, id: 'Shape_2', d: 'M21.379,10.4a2.457,2.457,0,0,0,2.228-1.875,2.264,2.264,0,0,0-.013-1.37l-1.8-5.47a.431.431,0,0,0-.349-.333H2.551a.431.431,0,0,0-.349.333L.405,7.153A2.275,2.275,0,0,0,.393,8.524,2.457,2.457,0,0,0,2.621,10.4,2.665,2.665,0,0,0,5,7.523a.75.75,0,1,1,1.5,0A2.665,2.665,0,0,0,8.874,10.4,2.665,2.665,0,0,0,11.25,7.523a.75.75,0,1,1,1.5,0A2.665,2.665,0,0,0,15.127,10.4,2.664,2.664,0,0,0,17.5,7.523a.75.75,0,1,1,1.5,0A2.666,2.666,0,0,0,21.379,10.4Z' })
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CommercialIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return CommercialIcon;
}(_react2.default.Component);

exports.default = CommercialIcon;